import { prop } from 'ramda';

import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

export const isToothIsInROI = prop<keyof Tooth>('IsInROI');
